define(["local-storage"], function (LocalStorage) {
  var localStorage = new LocalStorage();

  function setOptionState(productId, optionId, choiceId) {
    var savedState = localStorage.getFromLocalStorage("option-state-" + productId);

    if (savedState) {
      savedState = JSON.parse(savedState);
    }
    else {
      savedState = [];
    }

    var updated = false;
    for (var i = 0; i < savedState.length; i++) {
      if (savedState[i].optionId === optionId) {
        savedState[i].id = choiceId;
        updated = true;
        break;
      }
    }

    if (!updated) {
      savedState.push({ optionId: optionId, id: choiceId });
    }

    localStorage.persist("option-state-" + productId, JSON.stringify(savedState));
  }

  function removeOptionState(productId, optionId) {
    var savedState = localStorage.getFromLocalStorage("option-state-" + productId);

    if (savedState) {
      savedState = JSON.parse(savedState);

      for (var i = 0; i < savedState.length; i++) {
        if (savedState[i].optionId === optionId) {
          savedState.splice(i, 1);
          break;
        }
      }

      localStorage.persist("option-state-" + productId, JSON.stringify(savedState));
    }
  }

  return {
    setOptionState: setOptionState,
    removeOptionState: removeOptionState
  };
});